import { Mail, MapPin, Phone } from 'lucide-react';
import { COMPANY_INFO, LEGAL_LAST_UPDATED } from '../constants/companyInfo';

export default function LegalPageLayout({ title, children }) {
  return (
    <section className="section-padding bg-slate-50 dark:bg-slate-950 min-h-[70vh]">
      <div className="container-custom">
        <div className="max-w-5xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-black text-slate-900 dark:text-white mb-3">{title}</h1>
            <p className="text-sm text-slate-600 dark:text-slate-300">Son güncelleme: {LEGAL_LAST_UPDATED}</p>
          </div>

          <div className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-6 md:p-8">
            <div className="prose prose-slate dark:prose-invert max-w-none prose-headings:font-bold prose-h2:text-xl prose-h2:mt-8 prose-h2:mb-3 prose-p:leading-7 prose-li:leading-7">
              {children}
            </div>
          </div>

          <div className="mt-6 rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-5">
            <h2 className="text-lg font-bold text-slate-900 dark:text-white mb-3">İletişim</h2>
            <div className="grid gap-3 text-sm text-slate-700 dark:text-slate-300">
              <a href={`mailto:${COMPANY_INFO.email}`} className="flex items-center gap-2 hover:text-primary transition-colors">
                <Mail className="w-4 h-4 shrink-0" />
                <span className="break-all">{COMPANY_INFO.email}</span>
              </a>
              <a href={`tel:${COMPANY_INFO.phoneTel}`} className="flex items-center gap-2 hover:text-primary transition-colors">
                <Phone className="w-4 h-4 shrink-0" />
                <span>{COMPANY_INFO.phoneDisplay}</span>
              </a>
              <p className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span className="leading-6">{COMPANY_INFO.address}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
